import { render } from "./Layout.vue?vue&type=template&id=5865f0d8"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import exportComponent from "E:\\intellijIDEA\\Project\\yun_ji_shi_ben_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__